var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLanguageCircleIcon = function SvgLanguageCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.858 5.602H4.48M7.668 4.55V5.6M9.266 5.588c0 2.687-2.148 4.862-4.793 4.862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.865 10.45c-1.15 0-2.173-.6-2.908-1.544"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.668 13.75c3.53 0 6.391-2.798 6.391-6.25s-2.861-6.25-6.39-6.25c-3.53 0-6.392 2.798-6.392 6.25s2.862 6.25 6.391 6.25Z"
  })));
};
export default SvgLanguageCircleIcon;